import { NameKeyPair } from "./";

/** Declare default trend types before SPORTS_LIST */
export const DEFAULT_TREND_TYPES: Array<NameKeyPair> = [
  { name: "Spread", key: "ats", url: "spread" },
  { name: "Moneyline", key: "ml", url: "moneyline" },
];
